import { createContext } from 'react';

type ChatBoxContextValue = {
  openChat: (jobKey: string) => void;
  isChatOpen: boolean;
};

const contextDefaultValue: ChatBoxContextValue = {
  openChat: () => null,
  isChatOpen: false,
};

export const ChatBoxContext = createContext(contextDefaultValue);
